import {  BoundNodeCallbackObservable  } from './BoundNodeCallbackObservable';

export const bindNodeCallback = BoundNodeCallbackObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/bindNodeCallback.ts